import mitt from "mitt";
const emitter = mitt();

// Event Component
const LOADER = "LOADER";

// EventBus Action
const SHOW = "_SHOW";
const HIDE = "_HIDE";

// EventBusに使うキーを定義する
let Event = {
  Loader: {
    Show: LOADER + SHOW,
    Hide: LOADER + HIDE,
  }
};

// Vue3ではEventBusが標準で使用できなくなったので
// emitterをWrapする
let EventBus = {
  $on: (...args) => emitter.on(...args),
  $off: (...args) => emitter.off(...args),
  $emit: (...args) => emitter.emit(...args),
};

export { Event, EventBus };
